import { Component, OnInit } from '@angular/core';
import { RoutingStateService } from 'src/app/services/routing-state.service';

@Component({
    selector: 'app-bread-crumb-navigation',
    templateUrl: './bread-crumb-navigation.component.html',
    styleUrls: ['./bread-crumb-navigation.component.css'],
    standalone: false
})
export class BreadCrumbNavigationComponent implements OnInit {

  breadCrumbs$ = this.routingService.breadCrumbs$;

  constructor(private routingService: RoutingStateService) { }

  ngOnInit() {
  }

}
